/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
const goosdApis = {
  /**
   * 商品分组相关
   */
  // 获取商品sku
  getGoodsSku: {
    url: '/sku/skus',
    method: 'GET',
  },
  // 导入商品sku
  importGoodsSku: {
    url: '/sku/skus',
    method: 'POST',
  },
  // 商品分组列表查询
  getProductLineList: {
    url: '/productline/productlinelist',
    method: 'GET',
  },
  // 删除商品分组
  deleteProductLine: {
    url: '/productline/deleteproductline',
    method: 'POST',
  },
  // 商品分组新增接口
  addNewProduct: {
    url: '/productline/newproductline',
    method: 'POST',
  },
  // 商品分组新增接口
  updataProduct: {
    url: '/productline/updataproductlinelist',
    method: 'POST',
  },
  // 新增产品线 - 导入商品
  importProduct: {
    url: '/productline/newproductlinebyfile',
    method: 'POST',
  },
}

const exportObj = {};
Object.keys(goosdApis).forEach((key) => {
    exportObj[key] = {
        ...goosdApis[key],
        url: `/api${goosdApis[key].url}`
        // instanceName: 'marketing-request'
    }
});

export default exportObj;
